/**
 * Unwrap the first message from an API error envelope (`{ errors: [...] }`).
 * Returns null for anything that isn't a `Response` with a parseable body, so
 * callers can distinguish "the server explained itself" from an unexpected
 * failure worth reporting.
 *
 * @param {unknown} err - The rejection value from an $api call.
 * @returns {Promise<string|null>}
 */
export async function firstServerError(err) {
  if (!(err instanceof Response)) return null;

  try {
    const data = await err.json();
    return data.errors?.[0] || null;
  } catch {
    return null;
  }
}
